import React from "react";
import "./buttonGreyHLPure.css";

const ButtonGreyHLPure = (props) => {
    let {
        labelBtn,
        onClickBtn
    } = props

    return(
    <button
      {...props}
      type="button"
      className="buttonGreyHLPure-btn"
      onClick={onClickBtn}
    >
      {labelBtn}
    </button>
    )

}

export { ButtonGreyHLPure as default }